import { render, staticRenderFns } from "./VGridMask.vue?vue&type=template&id=6a5ac140&scoped=true&"
import script from "./VGridMask.vue?vue&type=script&lang=ts&"
export * from "./VGridMask.vue?vue&type=script&lang=ts&"
import style0 from "./VGridMask.vue?vue&type=style&index=0&id=6a5ac140&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5ac140",
  null
  
)

export default component.exports